module.exports = __webpack_public_path__ + "static/fonts/NanumGothic-Regular.95527de.ttf";